<template>
  <div :class="containerCssClass" @click="showPaymentForm">
    <i class="fas fa-plus fa-2x"></i>
    <span :class="textCssClass" style="margin-top: 7px;">New card</span>
  </div>
</template>

<script>
  export default {
    props: {
      active: {required: true}
    },
    computed: {
      containerCssClass() {
        return {'tdesk-new-credit-card': true, active: this.active}
      },
      textCssClass() {
        return {
          'tdesk-body--small': true,
          'tdesk-neutral-ultradark': !this.active,
          'tdesk.brand': this.active
        }
      }
    },
    methods: {
      showPaymentForm() {
        this.$emit('show-form')
      }
    }
  }
</script>